/*
Library detects when scroll is on start or end position
vertically and horizontally.

Initially, element got .scroll-horizontal-start when
scrollWidth is greater than offsetWidth.
Same situation is with .scroll-vertical-start.

When scroll is made on element, classes are removed.

When scroll is on the end, classes .scroll-horizontal-end
and/or .scroll-vertical-end are applied to element.

When scroll is in the middle of element, no classes
are applied to element.

Default, classes are applied to elements with .js-scroll-events,
but you can change this behavior to parents of that elements,
by setting data-scroll-event-reference="parent"
*/
import lozad from 'lozad';

const observer = lozad('.js-scroll-events', {
    load: (element) => {
        let reference = element;

        if (
            element.dataset.scrollEventsReference &&
            element.dataset.scrollEventsReference === 'parent'
        ) {
            reference = element.parentNode;
        }

        if (element.scrollWidth > reference.offsetWidth) {
            reference.classList.add('scroll-events-horizontal-on');
            reference.classList.add('scroll-horizontal-start');

            element.addEventListener(
                'scroll',
                (event) => {
                    event.stopPropagation();

                    if (
                        event.currentTarget.scrollWidth -
                            // ? Sometimes scrollLeft+offsetWidth is 0.5 smaller, so we subtract
                            0.5 <=
                        event.currentTarget.scrollLeft + event.currentTarget.offsetWidth
                    ) {
                        reference.classList.add('scroll-horizontal-end');
                    } else if (
                        event.currentTarget.scrollWidth >
                        event.currentTarget.scrollLeft + event.currentTarget.offsetWidth
                    ) {
                        reference.classList.remove('scroll-horizontal-end');
                    }

                    if (event.currentTarget.scrollLeft === 0) {
                        reference.classList.add('scroll-horizontal-start');
                    } else if (event.currentTarget.scrollLeft > 0) {
                        reference.classList.remove('scroll-horizontal-start');
                    }
                },
                { passive: true }
            );
        } else {
            reference.classList.add('scroll-events-horizontal-off');
        }

        if (element.scrollHeight > reference.offsetHeight) {
            reference.classList.add('scroll-events-vertical-on');
            reference.classList.add('scroll-vertical-start');

            element.addEventListener(
                'scroll',
                (event) => {
                    if (
                        event.currentTarget.scrollHeight <=
                        event.currentTarget.scrollTop + event.currentTarget.offsetHeight
                    ) {
                        reference.classList.add('scroll-vertical-end');
                    } else if (
                        event.currentTarget.scrollHeight >
                        event.currentTarget.scrollTop + event.currentTarget.offsetHeight
                    ) {
                        reference.classList.remove('scroll-vertical-end');
                    }

                    if (event.currentTarget.scrollTop === 0) {
                        reference.classList.add('scroll-vertical-start');
                    } else if (event.currentTarget.scrollTop > 0) {
                        reference.classList.remove('scroll-vertical-start');
                    }
                },
                { passive: true }
            );
        } else {
            reference.classList.add('scroll-events-vertical-off');
        }
    },
});

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        observer.observe();
    });
});
